import { useState, useEffect } from 'react';
import { DocumentClassList } from '../apiTypes';
import { fetchDocumentBankById } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';

export function useBankDocuments(bankId?: string) {
  useAxiosInterceptor();
  const [documents, setDocuments] = useState<DocumentClassList>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!bankId) return;

    const loadDocuments = async () => {
      setLoading(true);
      try {
        const data = await fetchDocumentBankById(bankId);
        setDocuments(data);
        setError(null);
      //  console.log('📄 Document classes:', data);
      } catch (err) {
        setError('Errore caricamento documenti banca');
        console.error('❌ Errore caricamento documenti banca:', err);
      } finally {
        setLoading(false);
      }
    };

    loadDocuments();
  }, [bankId]);

  return { documents, loading, error };
}
